import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  listMaltaEnAdmissionSignatures,
  templatesMaltaEnAdmissionCoursesSettings,
  templatesMaltaEnPaymentConfirmationCoursesSettings,
} from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";
import {
  listPolandEnAdmissionSignatures,
  templatesPolandEnAdmissionCoursesSettings,
  templatesPolandEnPaymentConfirmationCoursesSettings,
} from "@/src/constants/AdmissionOffice/Poland/AOPolandEnConsts";
import {
  listUkraineEnAdmissionSignatures,
  templatesUkraineEnAdmissionCoursesSettings,
  templatesUkraineEnPaymentConfirmationCoursesSettings,
} from "@/src/constants/AdmissionOffice/Ukraine/AOPUkraineEnConsts";
import type { AdmissionLetterBasicCourseTemplate } from "../AdmissionLetterBasic/admissionLetterBasicRegistry";

export type PaymentConfirmationTemplate = {
  tinyMCEContentHeader: string;
  tinyMCEContentFooter: string;
};

export type PaymentConfirmationBasicRegistryEntry = {
  signatures: Record<string, string>;
  admissionCourses: Record<string, AdmissionLetterBasicCourseTemplate>;
  paymentCourses: Record<string, PaymentConfirmationTemplate>;
};

export const PAYMENT_CONFIRMATION_BASIC_REGISTRY: Record<AdmissionOfficeCountry, PaymentConfirmationBasicRegistryEntry> = {
  malta: {
    signatures: listMaltaEnAdmissionSignatures,
    admissionCourses: templatesMaltaEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    paymentCourses: templatesMaltaEnPaymentConfirmationCoursesSettings,
  },
  poland: {
    signatures: listPolandEnAdmissionSignatures,
    admissionCourses: templatesPolandEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    paymentCourses: templatesPolandEnPaymentConfirmationCoursesSettings,
  },
  ukraine: {
    signatures: listUkraineEnAdmissionSignatures,
    admissionCourses: templatesUkraineEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    paymentCourses: templatesUkraineEnPaymentConfirmationCoursesSettings,
  },
};
